import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as refDataActionsCreators from '../../redux/css-admin/refData/refData'
import { Redirect, Route } from 'react-router-dom'
import { matchPath } from 'react-router'
import { Row, Col, Nav, TabContent } from 'reactstrap'
import LicenseManager from './licenses/LicenseManager'
import SitesManager from '../../components/SitesManager'
import UserManager from './users/UserManager'
import SubscriptionManager from './subscriptions/SubscriptionManager'
import UtilitiesLayout from './utilities/UtilitiesLayout'
import PakUploadContainer from './pakUpload/PakUploadContainer'
import { AdminNavBarItem, DeleteAccountModal } from 'components'
import {
  DeleteAccountActionWrapper,
  DeleteAccountButton,
} from './CssAdmin.styles'

class CssAdmin extends Component {
  static propTypes = {
    fetchAndHandleRoles: PropTypes.func.isRequired,
    fetchAndHandleSkus: PropTypes.func.isRequired,
    isCssAdmin: PropTypes.bool.isRequired,
    isOperationsAdmin: PropTypes.bool.isRequired,
    isTechnologyAdmin: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    productUser: PropTypes.object,
    showFooter: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      showDeleteAccountModal: false,
    }
    this.onShowModal = this.onShowModal.bind(this)
    this.onCloseModal = this.onCloseModal.bind(this)
  }

  componentDidMount = () => {
    this.props.showFooter(false)
    this.props.fetchAndHandleSkus()
  }

  onCloseModal = () => this.setState({ showDeleteAccountModal: false })
  onShowModal = () => this.setState({ showDeleteAccountModal: true })

  render = () => {
    const {
      match,
      isCssAdmin,
      isOperationsAdmin,
      isTechnologyAdmin,
      location,
      productUser,
    } = this.props
    const { showDeleteAccountModal } = this.state

    const matchUserProfile = matchPath(location.pathname, {
      path: `${match.path}/users/:email/:id`,
      exact: true,
      strict: true,
    })

    if (match.isExact) {
      if (isCssAdmin || isTechnologyAdmin) {
        return (
          <Redirect
            exact
            from={`${match.path}`}
            to={`${match.path}/licenses`}
          />
        )
      } else if (isOperationsAdmin) {
        return (
          <Redirect exact from={`${match.path}`} to={`${match.path}/pak`} />
        )
      } else {
        return <Redirect exact from={`${match.path}`} to={`${match.path}`} />
      }
    }

    return (
      <React.Fragment>
        <Row className="no-gutters">
          <Col className="col-auto">
            <LeftNavLinks
              isCssAdmin={isCssAdmin}
              isTechnologyAdmin={isTechnologyAdmin}
              path={match.path}
            />
          </Col>
          <Col className="end">
            <RightNavLinks
              isCssAdmin={isCssAdmin}
              isOperationsAdmin={isOperationsAdmin}
              isTechnologyAdmin={isTechnologyAdmin}
              path={match.path}
            />
          </Col>
        </Row>
        <TabContent
          className="tab-content-bordered"
          style={{ borderWidth: '0 1px 1px' }}
        >
          {(isCssAdmin || isTechnologyAdmin) && (
            <React.Fragment>
              <Route
                component={LicenseManager}
                path={`${match.path}/licenses`}
              />
              <Route component={UserManager} path={`${match.path}/users`} />
              <Route
                component={SubscriptionManager}
                path={`${match.path}/subscriptions`}
              />
              <Route component={SitesManager} path={`${match.path}/sites`} />
              <Route
                component={UtilitiesLayout}
                path={`${match.path}/utilities`}
              />
            </React.Fragment>
          )}
          <Route component={PakUploadContainer} path={`${match.path}/pak`} />
        </TabContent>
        {matchUserProfile && productUser && (
          <DeleteAccountActionWrapper>
            <DeleteAccountButton onClick={this.onShowModal}>
              <i className="fas fa-trash-alt" /> Delete Account
            </DeleteAccountButton>
          </DeleteAccountActionWrapper>
        )}
        {showDeleteAccountModal && (
          <DeleteAccountModal
            isModalOpen={showDeleteAccountModal}
            onCloseModal={this.onCloseModal}
          />
        )}
      </React.Fragment>
    )
  }
}

const LeftNavLinks = props => (
  <React.Fragment>
    {(props.isCssAdmin || props.isTechnologyAdmin) && (
      <Nav tabs>
        <AdminNavBarItem
          endpoint={props.path + '/licenses'}
          id="licenses"
          name="Licenses"
        />
        <AdminNavBarItem
          endpoint={props.path + '/sites'}
          id="sites"
          name="Sites"
        />
        <AdminNavBarItem
          endpoint={props.path + '/users'}
          id="users"
          name="Users"
        />
        <AdminNavBarItem
          endpoint={props.path + '/subscriptions'}
          id="subscriptions"
          name="Subscriptions"
        />
        <AdminNavBarItem
          endpoint={props.path + '/utilities'}
          id="utilities"
          name="Utilities"
        />
      </Nav>
    )}
  </React.Fragment>
)

LeftNavLinks.propTypes = {
  isCssAdmin: PropTypes.bool.isRequired,
  isTechnologyAdmin: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
}

const RightNavLinks = props => (
  <Nav className="justify-content-end" tabs>
    <AdminNavBarItem
      endpoint={props.path + '/pak'}
      icon="fas fa-file-upload"
      id="pak"
      name="Upload PAK Codes"
    />
    {/* {(props.isCssAdmin || props.isTechnologyAdmin) && (
      <AdminNavBarItem
        endpoint={props.path + '/reports'}
        icon="fas fa-table"
        id="reports"
        name="Reports"
      />
    )} */}
  </Nav>
)

RightNavLinks.propTypes = {
  isCssAdmin: PropTypes.bool.isRequired,
  isOperationsAdmin: PropTypes.bool.isRequired,
  isTechnologyAdmin: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
}

const mapStateToProps = ({ userManager }) => ({
  ...userManager,
})

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...refDataActionsCreators,
    },
    dispatch,
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(CssAdmin)



// WEBPACK FOOTER //
// ./src/containers/css-admin/CssAdmin.js